/**
 * GhlActionCard — Dashboard Build Engine P4 (2026-07-28).
 *
 * Marketing/CRM action card: once the tenant has said how they get customers
 * (Business Profile Q2), offer to organize contacts + outreach by kicking off a
 * Pi routine that uses the existing GHL tools (create_ghl_contact et al.). GHL
 * writes stay confirm-gated via ghlAgentStore (comms verbs Confirm-ONLY); the
 * per-tenant santabarbara-HFM guard is enforced at the GHL-tools layer, not here.
 * Shared ActionCard + startPiRoutine + buildMarketingSeed. §6 (Q2 → GHL).
 */
import { Megaphone } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { ActionCard } from './ActionCard';
import { runBuildStep, buildMarketingSeed } from './buildEngine';

export function GhlActionCard() {
  const customers = useDashboardStore((s) => s.profile.customers);
  const status = useDashboardStore((s) => s.buildState.crm);
  const setBuildStepStatus = useDashboardStore((s) => s.setBuildStepStatus);

  // Marketing keys off the "how do you get customers" answer (Q2).
  if (!customers.trim()) return null;

  return (
    <ActionCard
      testId="ghl-action-card"
      icon={<Megaphone className="h-5 w-5" />}
      title="Set up your marketing"
      description="Organize your contacts and outreach so you can reach more customers."
      preview={customers}
      previewTestId="ghl-action-preview"
      buttonLabel="Set up my marketing"
      buttonTestId="ghl-action-start"
      onAction={() => void runBuildStep('crm', buildMarketingSeed(customers))}
      status={status ?? 'todo'}
      onMarkDone={() => void setBuildStepStatus('crm', 'done')}
      onReopen={() => void setBuildStepStatus('crm', 'todo')}
    />
  );
}

export default GhlActionCard;
